
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/evento/[id]/[slug]",
      function () {
        return require("private-next-pages/evento/[id]/[slug]/index.tsx");
      }
    ]);
  